<template>
  <div class="skeleton-wrapper">
    <div
      class="skeleton"
      :style="skeletonStyle">
      <div class="skeleton__placeholder">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { cssValueOrSizeVar } from "#imports";

const props = withDefaults( defineProps<{
  width?: string | null;
  height?: string | null;
  shape?: "rounded" | "square";
}>(), {
  width: "100%",
  height: "s-4",
  shape: "square",
} );

const shape = computed( () => {
  let result = ".25rem";
  if ( props.shape === "rounded" ) {
    result = "50%";
  }
  return result;
} );

const skeletonStyle = computed( () => ( {
  width: props.width ? cssValueOrSizeVar( props.width ) ?? undefined : undefined,
  height: props.height ? cssValueOrSizeVar( props.height ) ?? undefined : undefined,
  borderRadius: shape.value,
} ) );
</script>

<style scoped lang="scss">
.skeleton {
  background-color: var(--color-gray-200);
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  display: inline-block;

  &:after {
    content: "";
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    position: absolute;
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .4), hsla(0, 0%, 100%, 0));
    transform: translateX(-100%);
    animation: loading 1.5s infinite;
  }

  &__placeholder {
    visibility: hidden;
  }

  &-wrapper {
    line-height: 1;
  }
}

@keyframes pulse {
  50% {
    opacity: .5;
  }
}

@keyframes loading {
  100% {
    transform: translateX(100%);
  }
}
</style>
